export const PANEL_ID = 'SOTNav';

export const getToggleSOTNavClick = (openPanel, isOpen, closePanel) => () => {
  if (isOpen) {
    closePanel();
  } else {
    openPanel(PANEL_ID);
  }
};
